import { useState, type ComponentPropsWithoutRef } from 'react'
import { useSteleBreakpoint } from '@/src/hooks/useBreakpoint'
import ButtonIcon from './ButtonIcon'
import IconChevron from '../icons/IconChevron'
import IconBolt from '../icons/IconBolt'
import IconChamele from '../icons/IconChamele'
import clsx from 'clsx'
import SnapCounterBadge from './SnapCounterBadge'

type GameControlPanelProps = ComponentPropsWithoutRef<'button'> & {
    direction?: 'left' | 'right'
    onSnap?: () => void;
    onJump?: () => void;
    snapDisabled?: boolean;
    batteryCount?: number;
}

export default function GameControlPanelStele({ direction, onSnap, onJump, snapDisabled, batteryCount = 0, ...buttonProps }: GameControlPanelProps) {
    const [isPressed, setIsPressed] = useState<boolean>(false)
    const isStele = useSteleBreakpoint();

    return (
        <>
            {direction === 'left' ?
                <div className='relative'>
                    <svg width={isStele ? '440' : '110'} height={isStele ? '540' : '135'} viewBox='0 0 110 135' fill='none' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' className='rotate-20'>
                        <g filter='url(#filter0_d_1660_662)'>
                            <path d='M36 0C55.8822 0 72 16.1178 72 36C72 40.5862 71.142 44.9717 69.5781 49.0052C67.8703 53.4098 69.4277 58.8692 73.8355 60.5688C74.599 60.8632 75.4099 61.0182 76.2268 61.0681C95.0719 62.2181 110 77.8656 110 97C110 116.882 93.8823 133 74 133C54.1177 133 38 116.882 38 97C38 90.9762 39.4789 85.2977 42.0943 80.3086C42.7512 79.0554 42.9853 77.6106 42.6382 76.2389C41.9704 73.5995 39.4043 71.9422 36.6822 71.9936C36.4553 71.9978 36.2279 72 36 72C16.1177 72 0 55.8823 0 36C6.1849e-06 16.1178 16.1178 0 36 0Z' fill='url(#paint0_linear_1660_662)' />
                            <path d='M36 0C55.8822 0 72 16.1178 72 36C72 40.5862 71.142 44.9717 69.5781 49.0052C67.8703 53.4098 69.4277 58.8692 73.8355 60.5688C74.599 60.8632 75.4099 61.0182 76.2268 61.0681C95.0719 62.2181 110 77.8656 110 97C110 116.882 93.8823 133 74 133C54.1177 133 38 116.882 38 97C38 90.9762 39.4789 85.2977 42.0943 80.3086C42.7512 79.0554 42.9853 77.6106 42.6382 76.2389C41.9704 73.5995 39.4043 71.9422 36.6822 71.9936C36.4553 71.9978 36.2279 72 36 72C16.1177 72 0 55.8823 0 36C6.1849e-06 16.1178 16.1178 0 36 0Z' fill='url(#pattern0_1660_662)' fill-opacity='0.35' />
                            <path d='M36 0C55.8822 0 72 16.1178 72 36C72 40.5862 71.142 44.9717 69.5781 49.0052C67.8703 53.4098 69.4277 58.8692 73.8355 60.5688C74.599 60.8632 75.4099 61.0182 76.2268 61.0681C95.0719 62.2181 110 77.8656 110 97C110 116.882 93.8823 133 74 133C54.1177 133 38 116.882 38 97C38 90.9762 39.4789 85.2977 42.0943 80.3086C42.7512 79.0554 42.9853 77.6106 42.6382 76.2389C41.9704 73.5995 39.4043 71.9422 36.6822 71.9936C36.4553 71.9978 36.2279 72 36 72C16.1177 72 0 55.8823 0 36C6.1849e-06 16.1178 16.1178 0 36 0Z' fill='url(#paint1_linear_1660_662)' fill-opacity='0.85' />
                        </g>
                        <defs>
                            <filter id='filter0_d_1660_662' x='0' y='0' width='110' height='135' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                                <feOffset dy='2' />
                                <feComposite in2='hardAlpha' operator='out' />
                                <feColorMatrix type='matrix' values='0 0 0 0 0.50364 0 0 0 0 0.65759 0 0 0 0 0.779468 0 0 0 1 0' />
                                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1660_662' />
                                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1660_662' result='shape' />
                            </filter>
                            <pattern id='pattern0_1660_662' patternContentUnits='objectBoundingBox' width='1' height='1'>
                                <use xlinkHref='#image0_1660_662' transform='matrix(0.000964187 0 0 0.000797448 -0.104545 0)' />
                            </pattern>
                            <linearGradient id='paint0_linear_1660_662' x1='55.0002' y1='133' x2='55.0002' y2='-1.47745e-07' gradientUnits='userSpaceOnUse'>
                                <stop stopColor='#C8E3F7' />
                                <stop offset='1' stopColor='white' />
                            </linearGradient>
                            <linearGradient id='paint1_linear_1660_662' x1='0' y1='0' x2='130.638' y2='108.047' gradientUnits='userSpaceOnUse'>
                                <stop stopColor='white' />
                                <stop offset='0.25' stopColor='white' stop-opacity='0' />
                                <stop offset='0.504815' stopColor='white' />
                                <stop offset='0.75' stopColor='white' stop-opacity='0' />
                                <stop offset='1' stopColor='white' />
                            </linearGradient>
                        </defs>
                    </svg>
                    <div
                        className={clsx(
                            'absolute',
                            'right-1.5 bottom-2',
                            'stele:right-17 stele:bottom-3 '
                        )}
                    >
                        <ButtonIcon
                            icon={<IconChevron width='100%' height='100%' />}
                            variant='move'
                            color='blue'
                            onPointerDown={(e) => {
                                if (e.pointerType === 'touch') {
                                    e.preventDefault()
                                }
                                e.currentTarget.setPointerCapture(e.pointerId)
                                setIsPressed(true)
                                buttonProps.onPointerDown?.(e)
                            }}
                            onPointerUp={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }
                                buttonProps.onPointerUp?.(e)
                            }}
                            onPointerLeave={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }
                                buttonProps.onPointerLeave?.(e)
                            }}
                            onPointerCancel={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }
                                buttonProps.onPointerCancel?.(e)
                            }}
                        />
                    </div>
                    <div
                        className={clsx(
                            'absolute flex justify-center items-center',
                            'top-1.5 left-1.5',
                            'stele:top-1 stele:left-19')}
                    >
                        {!snapDisabled &&
                            <img src='/images/Round_Electric.gif' className='z-50 absolute scale-200 pointer-events-none' />
                        }
                        <ButtonIcon
                            icon={<IconBolt width='100%' height='100%' />}
                            variant='move'
                            color='green'
                            disabled={snapDisabled}
                            onPointerDown={(e) => {
                                if (e.pointerType === 'touch') e.preventDefault()
                                e.currentTarget.setPointerCapture(e.pointerId)
                                setIsPressed(true)
                                onSnap?.()

                            }}
                            onPointerUp={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }

                            }}
                            onPointerLeave={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }

                            }}
                            onPointerCancel={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }

                            }}
                        />
                        {!snapDisabled && batteryCount > 1 ? (
                            <SnapCounterBadge
                                count={batteryCount}
                                className='bottom-8 stele:bottom-32 -left-4 stele:-left-18 z-10 absolute pointer-events-none'
                            />
                        ) : null}
                    </div >
                </div >
                :
                <div >
                    <svg width={isStele ? '440' : '110'} height={isStele ? '540' : '135'} viewBox='0 0 110 135' fill='none' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' className='-rotate-20'>
                        <g filter='url(#filter0_d_1660_627)'>
                            <path d='M74 0C54.1178 0 38 16.1178 38 36C38 40.5862 38.858 44.9717 40.4219 49.0052C42.1297 53.4098 40.5723 58.8692 36.1645 60.5688C35.401 60.8632 34.5901 61.0182 33.7732 61.0681C14.9281 62.2181 5.95263e-06 77.8656 0 97C0 116.882 16.1177 133 36 133C55.8823 133 72 116.882 72 97C72 90.9762 70.5211 85.2977 67.9057 80.3086C67.2488 79.0554 67.0147 77.6106 67.3618 76.2389C68.0296 73.5995 70.5957 71.9422 73.3178 71.9936C73.5447 71.9978 73.7721 72 74 72C93.8823 72 110 55.8823 110 36C110 16.1178 93.8822 0 74 0Z' fill='url(#paint0_linear_1660_627)' />
                            <path d='M74 0C54.1178 0 38 16.1178 38 36C38 40.5862 38.858 44.9717 40.4219 49.0052C42.1297 53.4098 40.5723 58.8692 36.1645 60.5688C35.401 60.8632 34.5901 61.0182 33.7732 61.0681C14.9281 62.2181 5.95263e-06 77.8656 0 97C0 116.882 16.1177 133 36 133C55.8823 133 72 116.882 72 97C72 90.9762 70.5211 85.2977 67.9057 80.3086C67.2488 79.0554 67.0147 77.6106 67.3618 76.2389C68.0296 73.5995 70.5957 71.9422 73.3178 71.9936C73.5447 71.9978 73.7721 72 74 72C93.8823 72 110 55.8823 110 36C110 16.1178 93.8822 0 74 0Z' fill='url(#pattern0_1660_627)' fill-opacity='0.35' />
                            <path d='M74 0C54.1178 0 38 16.1178 38 36C38 40.5862 38.858 44.9717 40.4219 49.0052C42.1297 53.4098 40.5723 58.8692 36.1645 60.5688C35.401 60.8632 34.5901 61.0182 33.7732 61.0681C14.9281 62.2181 5.95263e-06 77.8656 0 97C0 116.882 16.1177 133 36 133C55.8823 133 72 116.882 72 97C72 90.9762 70.5211 85.2977 67.9057 80.3086C67.2488 79.0554 67.0147 77.6106 67.3618 76.2389C68.0296 73.5995 70.5957 71.9422 73.3178 71.9936C73.5447 71.9978 73.7721 72 74 72C93.8823 72 110 55.8823 110 36C110 16.1178 93.8822 0 74 0Z' fill='url(#paint1_linear_1660_627)' fill-opacity='0.85' />
                        </g>
                        <defs>
                            <filter id='filter0_d_1660_627' x='0' y='0' width='110' height='135' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                                <feOffset dy='2' />
                                <feComposite in2='hardAlpha' operator='out' />
                                <feColorMatrix type='matrix' values='0 0 0 0 0.50364 0 0 0 0 0.65759 0 0 0 0 0.779468 0 0 0 1 0' />
                                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1660_627' />
                                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1660_627' result='shape' />
                            </filter>
                            <pattern id='pattern0_1660_627' patternContentUnits='objectBoundingBox' width='1' height='1'>
                                <use xlinkHref='#image0_1660_627' transform='matrix(0.000964187 0 0 0.000797448 -0.104545 0)' />
                            </pattern>
                            <linearGradient id='paint0_linear_1660_627' x1='54.9998' y1='133' x2='54.9998' y2='-1.47745e-07' gradientUnits='userSpaceOnUse'>
                                <stop stopColor='#C8E3F7' />
                                <stop offset='1' stopColor='white' />
                            </linearGradient>
                            <linearGradient id='paint1_linear_1660_627' x1='110' y1='0' x2='-20.6382' y2='108.047' gradientUnits='userSpaceOnUse'>
                                <stop stopColor='white' />
                                <stop offset='0.25' stopColor='white' stop-opacity='0' />
                                <stop offset='0.504815' stopColor='white' />
                                <stop offset='0.75' stopColor='white' stop-opacity='0' />
                                <stop offset='1' stopColor='white' />
                            </linearGradient>
                        </defs>
                    </svg>

                    <div
                        className={clsx(
                            'absolute',
                            'bottom-2 left-1.5',
                            'stele:bottom-3 stele:left-17'
                        )}>
                        <ButtonIcon
                            icon={<IconChevron width='100%' height='100%' className='rotate-180' />}
                            variant='move'
                            color='blue'
                            onPointerDown={(e) => {
                                if (e.pointerType === 'touch') {
                                    e.preventDefault()
                                }
                                e.currentTarget.setPointerCapture(e.pointerId)
                                setIsPressed(true)
                                buttonProps.onPointerDown?.(e)
                            }}
                            onPointerUp={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }
                                buttonProps.onPointerUp?.(e)
                            }}
                            onPointerLeave={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }
                                buttonProps.onPointerLeave?.(e)
                            }}
                            onPointerCancel={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }
                                buttonProps.onPointerCancel?.(e)
                            }}
                        />
                    </div>

                    <div
                        className={clsx(
                            'absolute',
                            'top-1.5 right-1.5',
                            'stele:top-1 stele:right-18'
                        )}
                    >
                        <ButtonIcon
                            icon={<IconChamele width='100%' height='100%' />}
                            variant='move'
                            color='orange'
                            onPointerDown={(e) => {
                                if (e.pointerType === 'touch') e.preventDefault()
                                e.currentTarget.setPointerCapture(e.pointerId)
                                setIsPressed(true)
                                onJump?.()
                            }}
                            onPointerUp={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }

                            }}
                            onPointerLeave={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }

                            }}
                            onPointerCancel={(e) => {
                                setIsPressed(false)
                                try {
                                    e.currentTarget.releasePointerCapture(e.pointerId)
                                } catch {
                                    /* not captured */
                                }

                            }}
                        />
                    </div>
                </div>
            }
        </>

    )
}
